import type { SharedPaginationOptions } from "@/shared/types"
import type { ComposableOptions } from "@/types"
import type { MaybeRefOrGetter } from "vue"

type TariffPaginationOptions = ComposableOptions<SharedPaginationOptions & { ids: number[], yearOfTariff: string }>

export namespace tariffQueryKeys {
    export namespace tariffs {
        export function all(): readonly ['tariffs']
        export function all() {
            return ['tariffs'] as const
        }
        export function paginated(): readonly ['tariffs', 'paginated']
        export function paginated(options: TariffPaginationOptions): readonly ['tariffs', 'paginated', TariffPaginationOptions]
        export function paginated(options?: TariffPaginationOptions) {
        return options
            ? [...tariffQueryKeys.tariffs.all(), 'paginated', options] as const
            : [...tariffQueryKeys.tariffs.all(), 'paginated'] as const
        }
        export function providers(): readonly ['tariffs', 'providers']
        export function providers<T extends MaybeRefOrGetter<number[] | undefined>>(regions: T): readonly ['tariffs', 'providers', T]
        export function providers(regions?: MaybeRefOrGetter<number[] | undefined>) {
            return regions
            ? [...tariffQueryKeys.tariffs.all(), 'providers', regions] as const
            : [...tariffQueryKeys.tariffs.all(), 'providers'] as const
        }
        export function tariffNames(): readonly ['tariffs', 'tariffNames']
        export function tariffNames<T extends MaybeRefOrGetter<number[] | undefined>>(providers: T): readonly ['tariffs', 'tariffNames', T]
        export function tariffNames(providers?: MaybeRefOrGetter<number[] | undefined>) {
            return providers
            ? [...tariffQueryKeys.tariffs.all(), 'tariffNames', providers] as const
            : [...tariffQueryKeys.tariffs.all(), 'tariffNames'] as const
        }
        export function tariffYears(): readonly ['tariffs', 'tariffYears']
        export function tariffYears<T extends MaybeRefOrGetter<number[] | undefined>>(tariffs: T): readonly ['tariffs', 'tariffYears', T]
        export function tariffYears(tariffs?: MaybeRefOrGetter<number[] | undefined>) {
            return tariffs
            ? [...tariffQueryKeys.tariffs.all(), 'tariffYears', tariffs] as const
            : [...tariffQueryKeys.tariffs.all(), 'tariffYears'] as const
        }
    }
    export namespace assetTariffDashboard {
        export function all(): readonly ['assetTariffDashboard']
        export function all() {
            return ['assetTariffDashboard'] as const
        }
        export function paginated(): readonly ['assetTariffDashboard', 'paginated']
        export function paginated(options: SharedPaginationOptions): readonly ['assetTariffDashboard', 'paginated', SharedPaginationOptions]
        export function paginated(options?: SharedPaginationOptions) {
        return options
            ? [...tariffQueryKeys.assetTariffDashboard.all(), 'paginated', options] as const
            : [...tariffQueryKeys.assetTariffDashboard.all(), 'paginated'] as const
        }
    }
    export namespace timeOfUseConfigs {
       export function all(): readonly ['timeOfUseConfigs']
        export function all<T extends MaybeRefOrGetter<number | undefined>>(profileId: T): readonly ['timeOfUseConfigs', T]
        export function all(profileId?: MaybeRefOrGetter<number | undefined>) {
            return profileId
            ? [...tariffQueryKeys.timeOfUseConfigs.all(), profileId] as const
            : [...tariffQueryKeys.timeOfUseConfigs.all(),] as const
        }
    }
    
    export namespace rigions {
        export function all(): readonly ['regions']
        export function all() {
            return ['regions'] as const
        }
    }
}